export default __webpack_public_path__ + "static/image10-c207137a53cd9477383a9a534167b733.gif";